import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import Hubspot from 'app/main/common/Hubspot';
import HubspotButton from 'app/main/common/HubspotButton';
import Utils from 'utils/Utils';

const useStyles = makeStyles()({
    root: {
        padding: '0 100px 60px',
        position: 'relative',
        overflow: 'hidden',
        '@media (max-width: 1140px)': {
            padding: 'initial'
        }
    },
    slide: {
        maxWidth: 1180,
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexWrap: 'wrap',
        '@media (max-width: 1140px)': {
            flexDirection: 'column',
            alignContent: 'center',
            padding: 0,
            '&:nth-child(2)': {
                flexDirection: 'column'
            }
        }
    },
    box: {
        maxWidth: 480,
        '@media (max-width: 1140px)': {
            padding: 20
        }
    },
    title: {
        fontSize: 36
    },
    description: {
        fontSize: 18,
        paddingTop: 24,
        paddingBottom: 48
    },
    button: {
        fontSize: 16,
        padding: '16px 40px',
        borderRadius: 100
    },
    img: {
        maxWidth: 460,
        '@media (max-width: 1140px)': {
            marginBottom: 40
        },
        '@media (max-width: 720px)': {
            maxWidth: '100%'
        }
    }
});

const Assessment = () => {
    const { classes } = useStyles();
    const history = useHistory();

    const handleClick = (e) => {
        e.preventDefault();
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
        history.push('/assessment');
    };

    return (
        <Box className={classes.root} id="assessment">
            <Box className={classes.slide}>
                <img
                    src={Utils.getImage('landing/v2/benefit/assessment')}
                    alt="Vulners Vulnerability Assessment"
                    className={classes.img}
                />
                <Box display="flex" flexDirection="column" alignItems="flex-start" className={classes.box}>
                    <Typography className={classes.title} variant="h2">
                        Non-intrusive
                        <br />
                        vulnerability assessment
                    </Typography>
                    <Typography className={classes.description} variant="body2">
                        Deploy powerful vulnerability assessment service for internal Linux infrastructure, or as a part
                        of MSSP offering without headache and limitations of active scanning. No more accidental
                        down-times
                    </Typography>
                    <HubspotButton
                        hubspot={Hubspot.LANDING_MAIN_ASSESSMENT_LEARN_MORE}
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        href="/assessment"
                        onClick={handleClick}
                    >
                        Learn More
                    </HubspotButton>
                </Box>
            </Box>
        </Box>
    );
};

export default Assessment;
